export default __webpack_public_path__ + "static/media/dielectric-logos.8088e0f8.jpg";